import { useAppDispatch } from "@/shared/lib/redux"
import { 
    closeCreateUserIntegrationModal as closeCreateUserIntegrationModalAction, 
    closeDeleteUserIntegrationModal as closeDeleteUserIntegrationModalAction,
    closeUpdateUserIntegrationModal as closeUpdateUserIntegrationModalAction, 
    openCreateUserIntegrationModal as openCreateUserIntegrationModalAction, 
    openDeleteUserIntegrationModal as openDeleteUserIntegrationModalAction, 
    openUpdateUserIntegrationModal as openUpdateUserIntegrationModalAction 
} from "../../model"
import { IIntegration } from "@/shared/api/settings"

export const useUpdateUserIntegrationModal = () => {
    const dispatch = useAppDispatch()

    const openCreateUserIntegrationModal = (onSuccess?: () => void) => {
        dispatch(openCreateUserIntegrationModalAction({
            onSuccess
        }))
    }

    const openDeleteUserIntegrationModal = (data: IIntegration, onSuccess?: () => void) => {
        dispatch(openDeleteUserIntegrationModalAction({
            data,
            onSuccess
        }))
    }

    const openUpdateUserIntegrationModal = (data: IIntegration, onSuccess?: () => void) => {
        dispatch(openUpdateUserIntegrationModalAction({
            data,
            onSuccess
        }))
    }

    const closeUpdateUserIntegrationModal = () => {
        dispatch(closeUpdateUserIntegrationModalAction())
    }

    const closeDeleteUserIntegrationModal = () => {
        dispatch(closeDeleteUserIntegrationModalAction())
    }

    const closeCreateUserIntegrationModal = () => {
        dispatch(closeCreateUserIntegrationModalAction())
    }
    
    return {
        closeCreateUserIntegrationModal,
        closeUpdateUserIntegrationModal,
        closeDeleteUserIntegrationModal,
        openDeleteUserIntegrationModal,
        openCreateUserIntegrationModal,
        openUpdateUserIntegrationModal
    }
}